module.exports = __webpack_public_path__ + "static/media/bluetext.735a2d31.svg";